import { api } from "./client";
import type { User } from "./users";

export type Room = {
  id: string;
  tenant_id: string;
  customer_company_name: string;
  description: string | null;
  status: "active" | "archived";
  created_at: string;
  /** Enriquecimiento del endpoint /api/rooms */
  last_message_preview?: string | null;
  last_message_at?: string | null;
  unread_count?: number;
};

export const roomsApi = {
  myRooms: () => api.get<Room[]>("/rooms"),
  members: (roomId: string) => api.get<User[]>(`/rooms/${roomId}/members`),
  // Admin del tenant
  listAll: () => api.get<Room[]>("/tenant/rooms"),
  create: (payload: { customer_company_name: string; description?: string }) =>
    api.post<Room>("/tenant/rooms", payload),
  update: (id: string, payload: Partial<{ customer_company_name: string; description: string; status: string }>) =>
    api.patch<Room>(`/tenant/rooms/${id}`, payload),
  addMember: (roomId: string, userId: string) =>
    api.post<{ status: string }>(`/tenant/rooms/${roomId}/members`, { user_id: userId }),
  removeMember: (roomId: string, userId: string) =>
    api.delete<void>(`/tenant/rooms/${roomId}/members/${userId}`),
};
